/**
 * The active category the Campaign Category alias names. Admins type the alias by hand, so
 * it matches in any letter case: `Halloween` in the admin is the Skin's `halloween`.
 */
export function findCampaignCategory<T extends { alias: string; isActive: boolean }>(
  categories: T[],
  alias: string,
): T | undefined {
  const normalizedAlias = alias.toLowerCase();

  return categories.find(category => category.isActive && category.alias.toLowerCase() === normalizedAlias);
}
